class LocationsMap {
    constructor(el) {
        this.$el = $(el);

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.map = null;
        this.markers = [];
        this.locations = [];
        this.locationsCategoriesIds = [];

        this._initMap();

        if(this.$el[0].hasAttribute('data-locations-categories')) {
            let json = null;
            try {
                json = JSON.parse(this.$el.attr('data-locations-categories'));
            }
            catch(error) {
                console.log(error);
            }

            if(json) {
                this._getLocationsCategoriesIds(json);

                if(this.locationsCategoriesIds.length) {
                    this._fetchLocations();
                }
            }
        }
    }

    _initMap() {
        this.map = new google.maps.Map(this.$el[0], {
            zoom: 4,
            // center: new google.maps.LatLng(28, -70),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#000000"},{"lightness":13}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#144b53"},{"lightness":14},{"weight":1.4}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#08304b"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#0c4152"},{"lightness":5}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"simplified"},{"hue":"#ff0000"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#0b434f"},{"lightness":25}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#0b3d51"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"transit","elementType":"all","stylers":[{"color":"#146474"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#021019"}]}]
        });
    }

    _getLocationsCategoriesIds(locationsCategoriesIds) {
        if(Array.isArray(locationsCategoriesIds)) {
            locationsCategoriesIds.forEach((locationCategoryId) => {
                if(!isNaN(locationCategoryId)) {
                    this.locationsCategoriesIds.push(parseInt(locationCategoryId, 10));
                }
            });
        }
    }

    _fetchLocations() {
        var formData = {
            action: 'get_locations',
            locations_categories: this.locationsCategoriesIds,
            locations_maps_nonce: ver.nonce ? ver.nonce : ''
        };

        var request = $.ajax({
            url: ver.ajax_url,
            type: 'post',
            data: formData,
            // dataType: 'html',
            dataType: 'json',
            // beforeSend: this.lockSearchFn
        });
        request.done(this._onFetchLocationsDone.bind(this));
        request.fail(this._onFetchLocationsFail.bind(this));
        // request.always(this._onFetchLocationsAlways.bind(this));
    }

    _onFetchLocationsDone(response) {
        let locations = null;

        try {
            locations = JSON.parse(response.data.locations)
        }
        catch(error) {
            console.log(error);
        }

        if(locations) {
            this.locations = locations;

            this._createMarkers();
            this._centerMap();
        }
    }

    _onFetchLocationsFail(data) {
        console.log('_onFetchLocationsFail', data);
    }

    _createMarkers() {
        this.locations.forEach((location) => {
            const latlng = this._createGpsCoordinatesFromString(location.gps);

            if(latlng) {
                let marker = new google.maps.Marker({
                    position: new google.maps.LatLng(latlng[0], latlng[1]),
                    map: this.map,
                    icon: location.marker_icon
                });

                marker.infoWindow = new google.maps.InfoWindow({
                    content: `
                        <div class="location-popup">
                            <img src="${location.picture}" alt=""/>
                            <p class="location-title"><strong>${location.title}</strong></p>
                            <p class="spacing">${location.address}<br/>${location.country}</p>
                            <p class="spacing"><a href="${location.phone}">${location.phone}</a></p>
                            <div class="spacing">${location.business_group}</div>
                        </div>
                    `,
                    maxWidth: 350
                    // pixelOffset: new google.maps.Size(250,150)
                });

                // Show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', this._onMarkerClick.bind(this, marker));

                this.markers.push(marker);
            }
        });
    }

    _onMarkerClick(marker) {
        this._closeAllInfoWindows();

        if(marker.infoWindow) {
            this.map.panTo(marker.getPosition());
            marker.infoWindow.open(this.map, marker);
        }
    }

    // Map.prototype.focusMarker = function(id) {
    //     if(this.map.markers[id]) {
    //         this.closeAllInfoWindows();
    //         this.map.setZoom(3);
    //         var marker = this.map.markers[id];
    //         var markerPos = marker.getPosition();
    //         // var newPos = new google.maps.LatLng(pt.lat() + .02, pt.lng());
    //         var newPos = new google.maps.LatLng(markerPos.lat(), markerPos.lng());
    //         this.map.panTo(markerPos);
    //         marker.infoWindow.open(this.map, marker);
    //     }
    // };

    _closeAllInfoWindows() {
        this.markers.forEach((marker) => {
            if(marker.infoWindow) {
                marker.infoWindow.close();
            }
        });
    }

    _centerMap() {
        let bounds = new google.maps.LatLngBounds();

        this.markers.forEach((marker) => {
            let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            bounds.extend(latlng);
        });

        if(this.markers.length > 1) {
            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);
        }
        else {
            this.map.setCenter(bounds.getCenter());
            this.map.setZoom(4);
        }
    }

    _createGpsCoordinatesFromString(str) {
        const comaIndex = str.indexOf(',');

        if(comaIndex !== -1) {
            const strParts = str.split(',');
            let coordinates = strParts.map(strPart => parseFloat(strPart.trim()));

            coordinates = coordinates.filter(coordinate => !isNaN(coordinate));

            if(coordinates.length === 2) {
                return coordinates;
            }
        }

        return false;
    };
}

export default LocationsMap;
